import React from 'react'
import PropTypes from 'prop-types'

import { FormContext } from './context'

import * as styles from './styles'

const FormComponent = ({ form, className, children, onInternalSubmit }) => (
  <FormContext.Provider value={form}>
    <form noValidate className={className} onSubmit={onInternalSubmit}>
      {children}
      <input value="" type="submit" css={styles.hiddenInput} tabIndex="-1" />
    </form>
  </FormContext.Provider>
)

FormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onInternalSubmit: PropTypes.func,
}

export default FormComponent
